<script>
export default {
  name: "fuel-price-modal",
  data: function() {
    return {
      fuelPrice: "",
      fuelUnit: "",
    };
  },
  components: {},
  methods: {
    async onSaveChanges() {
      this.$store.commit("setFuelPriceData", { fuelPrice: this.fuelPrice, fuelUnit: this.fuelUnit });
      this.onModalClose();
    },
    onModalShown: function() {
      this.fuelPrice = this.$store.state.fuelPrice;
      this.fuelUnit = this.$store.state.fuelUnit;
    },
    onModalClose: function() {
      this.$store.commit("toggleFuelPriceModal", false);
    },
    setFuelUnit: function(u) {
      this.fuelUnit = u;
    },
    addCommas: function(x) {
      if (x === null) {
        return null;
      } else if (isNaN(x)) {
        return 0;
      }
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    updateValue: function(value) {
      this.fuelPrice = value ? parseInt(value.replace(/\,/g, "")) : null;
    },
  },
  computed: {
    modalVisible: function() {
      return this.$store.state.fuelPriceModalShown;
    },
    auctionCurrency: function() {
      return this.$store.state.activeAuction.currency;
    },
    unitDisplay: function() {
      var u = this.fuelUnit;
      if (!u) {
        return "--Select Unit--";
      } else if (u == "M") {
        return "per m³ ";
      } else {
        return "per tonne";
      }
    },
  },
};
</script>
<template>
  <div>
    <b-modal id="custom-fuel-cost--modal" title="Fuel Cost" v-on:shown="onModalShown" v-on:hidden="onModalClose" :hide-footer="true" v-model="modalVisible">
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <b-input-group size="lg" :prepend="auctionCurrency">
              <b-form-input :value="addCommas(fuelPrice)" v-on:input.native="updateValue($event.target.value)"></b-form-input>
              <template v-slot:append>
                <b-dropdown :text="unitDisplay" variant="success">
                  <b-dropdown-item v-on:click="setFuelUnit('M')">/m&sup3;</b-dropdown-item>
                  <b-dropdown-item v-on:click="setFuelUnit('T')">/tonne</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <button class="btn btn-light" style="width:100%" type="button" v-on:click="onSaveChanges">
              <span class="login-button-content">Update</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
